// extracted by mini-css-extract-plugin
module.exports = {"container":"Divider_container__xrGnC","line":"Divider_line__1-uLA","center":"Divider_center__MXEr8"};